import { render, staticRenderFns } from "./SignedUp.vue?vue&type=template&id=c9b7e1ec&"
import script from "./SignedUp.vue?vue&type=script&lang=js&"
export * from "./SignedUp.vue?vue&type=script&lang=js&"
import style0 from "./SignedUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports